// src/hooks/useCurrentUser.js
import { useMemo } from "react";

export function useCurrentUser() {
  const currentUser = useMemo(() => {
    try {
      const cu = localStorage.getItem("currentUser");
      return cu ? JSON.parse(cu) : null;
    } catch {
      return null;
    }
  }, []);
  const currentUserId = currentUser?.id ?? null;
  const profilePicture = currentUser?.profile_picture ?? null;
  const firstName = currentUser?.first_name ?? "";
  const lastName = currentUser?.last_name ?? "";
  const position = currentUser?.position ?? null;
  const userType = currentUser?.userType 
  const companyId = currentUser?.company_id
  const startingMonth = currentUser?.starting_month
  const frequency = currentUser?.frequency
  const isHead = currentUser.is_head
  let allSources = JSON.parse(currentUser.source_ids)
  allSources = allSources.map(d=>parseInt(d))
  


  return {
    currentUser,
    currentUserId,
    profilePicture,
    firstName,
    lastName,
    position,
    userType,
    companyId,
    startingMonth,
    frequency,
    isHead,
    allSources
    };
}
